import React, { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import {
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  ResponsiveContainer,
  Legend
} from 'recharts';

const TimeCompetencyRadar = ({ results }) => {
  const data = useMemo(() => {
    const timeSpent = results.questions.find(q => q.questionKey === 'time_spent')?.rankings || [];
    const timeDesired = results.questions.find(q => q.questionKey === 'time_desired')?.rankings || [];
    const competencies = results.questions.find(q => q.questionKey === 'competency')?.rankings || [];

    return timeSpent.map(current => ({
      activity: current.item.substring(0, 20) + '...', // Truncate for better display
      current: current.score * 100,
      desired: timeDesired.find(d => d.item === current.item).score * 100,
      competency: competencies.find(c => c.item === current.item).score * 100
    }));
  }, [results]);

  return (
    <Box sx={{ 
      width: '100%', 
      height: '100%',
      display: 'flex',
      flexDirection: 'column'
    }}>
      <Typography variant="h6" gutterBottom align="center">
        Équilibre Temps-Compétence
      </Typography>
      <Box sx={{ 
        flex: 1, 
        minHeight: 0,
        width: '100%',
        position: 'relative'
      }}>
        <ResponsiveContainer width="100%" height="100%" debounce={50}>
          <RadarChart data={data} margin={{ top: 20, right: 30, bottom: 30, left: 30 }}>
            <PolarGrid />
            <PolarAngleAxis 
              dataKey="activity"
              tick={{ fontSize: 12 }}
              tickLine={false}
            />
            <PolarRadiusAxis 
              domain={[0, 100]}
              tickCount={5}
            />
            <Radar
              name="Temps Actuel"
              dataKey="current"
              stroke="#8884d8"
              fill="#8884d8"
              fillOpacity={0.3}
            />
            <Radar
              name="Temps Souhaité"
              dataKey="desired"
              stroke="#82ca9d"
              fill="#82ca9d"
              fillOpacity={0.3}
            />
            <Radar
              name="Compétence"
              dataKey="competency"
              stroke="#ffc658"
              fill="#ffc658"
              fillOpacity={0.3}
            />
            <Legend 
              wrapperStyle={{ 
                paddingTop: '20px',
                fontSize: '12px'
              }} 
            />
          </RadarChart>
        </ResponsiveContainer>
      </Box>
    </Box>
  );
};

export default TimeCompetencyRadar;